import { useNetwork } from '@vueuse/core';
import StatusCom from '../components/personalspace/StatusCom.vue';
export default {
  __name: 'InternetDisconnected',
  props: {
    isOnline: {
      type: Boolean,
      default: true
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const props = __props;
    const handleRefresh = () => {
      if (props.isOnline) {
        window.location.reload();
      }
    };
    const __returned__ = {
      props,
      handleRefresh,
      get useNetwork() {
        return useNetwork;
      },
      StatusCom
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};